import { DetailItemProps } from '@/components/DetailItem'
import { AuditTrail } from '@/hooks/queries/useAuditTrails'
import { useTranslation } from 'react-i18next'
import { MAX_EVENT_DETAILS_LENGTH } from './constants'

export const useEventDetails = (auditTrail: AuditTrail) => {
  const { t } = useTranslation('admin')

  const details: DetailItemProps[] = []

  if (auditTrail.eventDetails.s3UploadType)
    details.push({
      label: t('auditDetailsSheetContent.s3UploadType'),
      children: auditTrail.eventDetails.s3UploadType,
    })

  if (auditTrail.eventDetails.orderPoNumber)
    details.push({
      label: t('auditDetailsSheetContent.orderPoNumber'),
      children: auditTrail.eventDetails.orderPoNumber,
    })

  if (auditTrail.eventDetails.sapErp)
    details.push({
      label: t('auditDetailsSheetContent.sapErp'),
      children: auditTrail.eventDetails.sapErp,
    })

  if (auditTrail.eventDetails.launchId)
    details.push({
      label: t('auditDetailsSheetContent.launchId'),
      children: auditTrail.eventDetails.launchId,
    })

  if (auditTrail.eventDetails.userId)
    details.push({
      label: t('auditDetailsSheetContent.userId'),
      children: auditTrail.eventDetails.userId,
    })

  if (auditTrail.eventDetails.backupId)
    details.push({
      label: t('auditDetailsSheetContent.backupId'),
      children: auditTrail.eventDetails.backupId,
    })

  if (auditTrail.eventDetails.entityId)
    details.push({
      label: t('auditDetailsSheetContent.entityId'),
      children: auditTrail.eventDetails.entityId,
    })

  return details
}

export const getEventDetailsAsJson = (data: AuditTrail['eventDetails']['data']) => {
  return JSON.stringify(data, null, 2)
}

export const isEventDetailsTooLong = (data: AuditTrail['eventDetails']['data']) => {
  return getEventDetailsAsJson(data).length > MAX_EVENT_DETAILS_LENGTH
}
